import { atom } from "jotai";
export const systemsAtom = atom([]);
export const systemsLoadingAtom = atom(true);
